<h2 mat-dialog-title class="mb-3">Create Asset Id</h2>

<mat-dialog-content>
  <form [formGroup]="assetForm" (ngSubmit)="submitData()" class="w-100">
    <!-- Panel Select -->
    <mat-form-field appearance="fill" class="w-100 mb-2">
      <mat-label>Panel Name</mat-label>
      <mat-select formControlName="panelName">
        <mat-option *ngFor="let item of panelList" [value]="item.id">
          {{ item.displayName }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Club Select -->
    <mat-form-field appearance="fill" class="w-100 mb-2">
      <mat-label>Club Name</mat-label>
      <mat-select formControlName="clubId">
        <mat-option *ngFor="let item of clubList" [value]="item.id">
          {{ item.displayName }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Multi Profile Select -->
    <mat-form-field appearance="fill" class="w-100 mb-2">
      <mat-label>Video Profile</mat-label>
      <mat-select formControlName="profile">
        <mat-option [value]="0">Single Profile</mat-option>
        <mat-option [value]="1">Multi Profile</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-dialog-actions class="d-flex justify-content-end gap-2 mt-2">
      <button mat-raised-button color="primary" type="submit">Create</button>
    <button mat-stroked-button mat-dialog-close color="warn" type="button">Close</button>
  </mat-dialog-actions>

  </form>
</mat-dialog-content>

